var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0058 17.0158C9.87419 17.0166 9.74373 16.9913 9.62189 16.9416C9.50005 16.8918 9.38924 16.8185 9.2958 16.7258C9.20207 16.6328 9.12768 16.5222 9.07691 16.4004C9.02614 16.2785 9 16.1478 9 16.0158C9 15.8838 9.02614 15.7531 9.07691 15.6312C9.12768 15.5094 9.20207 15.3988 9.2958 15.3058L12.6058 12.0158L9.4258 8.7058C9.23955 8.51844 9.13501 8.26498 9.13501 8.0008C9.13501 7.73661 9.23955 7.48316 9.4258 7.2958C9.51876 7.20207 9.62936 7.12768 9.75122 7.07691C9.87308 7.02614 10.0038 7 10.1358 7C10.2678 7 10.3985 7.02614 10.5204 7.07691C10.6422 7.12768 10.7528 7.20207 10.8458 7.2958L14.7058 11.2958C14.889 11.4827 14.9917 11.734 14.9917 11.9958C14.9917 12.2576 14.889 12.5089 14.7058 12.6958L10.7058 16.6958C10.616 16.7927 10.508 16.8709 10.3878 16.9258C10.2677 16.9808 10.1378 17.0113 10.0058 17.0158Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.98542f26e2f4938be2975fbf3a59098d.svg";
export { ForwardRef as ReactComponent };